/*
 * AbTestWrapper
 * Framework level module not to be modified for AbTest implementations
 * Used to check AbTest class validation, logging, registration on the global scope
 * and adds debugging capabilities when running on lower environments
 * */
export const has = (obj, property) => obj[property] !== 'undefined';
export const silent = !RegExp('^local|^test-www|^stage|^www.stage.intl|^shadow|^www.dev.intl').test(CBS.Registry?.host);

/**
 * Validates if class implemented is an experiment object
 * @param abTest
 * @return {boolean}
 */
function isAbTest(abTest) {
    return (
        typeof abTest === 'object' &&
        has(abTest, 'objectType') &&
        has(abTest, 'experimentKey') &&
        has(abTest, 'isXHR') &&
        (has(abTest, 'onRun') || abTest.isXHR === false)
    );
}

/**
 * Throws error and provides reference when abtest clases are invalid
 * @param abTest
 */
function assertIsAbTest(abTest) {
    if (!isAbTest(abTest)) {
        throw new TypeError(
            `Not a fully implemented AbTest. Experiment key or onRun is missing on the test class`,
        );
    }
}

/**
 * Implements the test, runs validation, registers it on the global scope, and adds debugging functions
 * when on lower environments
 * and
 * @param abTest
 */
export function implementAbTest(abTest) {
    assertIsAbTest(abTest);
    registerOnGlobalScope(abTest);
    if (silent) return;
    extendFunctionality(abTest);
    // console.table(abTest);
    console.info(
        'type: %s, module: %s xhr: %s experiment key: %s active variant: %s',
        abTest.objectType,
        abTest.name,
        abTest.isXHR,
        abTest.experimentKey,
        abTest.activeVariant,
    );
}

// TODO: move out of global scope
/**
 * Registers the abtest instance on the global scope for re-usability and debugging
 * @param abTest
 */
function registerOnGlobalScope(abTest) {
    try {
        if (!window['abTests']) {
            window['abTests'] = {};
        }
        window['abTests'][abTest.name.split('.')[0]] = abTest;
    } catch {}
}

/**
 * Extend the abTest class functionality
 * @param abTest
 */
function extendFunctionality(abTest) {
    abTest.overrideVariant = (variant) => {
        abTest.activeVariant = variant;
        addVariantClassToBody(abTest);
        return abTest;
    };
    abTest.debug = () => {
        debugger;
        abTest.onRun();
    };
}

/**
 * Adds/Replace body class for debugging
 * @param abTest
 */
function addVariantClassToBody(abTest) {
    const docElem = document.documentElement;
    const bodyElem = docElem.querySelector('body');
    Array.from(bodyElem.classList).map(function (val) {
        if (val.includes(abTest.experimentKey)) {
            bodyElem.classList.remove(val);
        }
    });
    bodyElem.classList.add(`test-${abTest.experimentKey}-${abTest.activeVariant}`);
}
